import React, { useContext } from "react";
import { PageMedia, useTranslator } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";
import { resolveLang, VIDEO_BY_LANG } from "components/Media/VideoConfig";

// eslint-disable-next-line react/prop-types
const ExplanatoryVideo = ({ className = "", copyrightOwner = "SIA" }) => {
  const { language: lang } = useContext(GlobalContext) || {};
  const translate = useTranslator();

  const langKey = resolveLang(lang);
  const { src, image } = VIDEO_BY_LANG[langKey] || VIDEO_BY_LANG.DE;

  const items = [
    {
      src,
      type: "VIDEO",
      playButtonCenter: true,
      imagePlaceholder: image,
      copyright: {
        title: translate("benchmarking.side-bar.link.explanatory-video"),
        copyrightVideo: copyrightOwner,
      },
    },
  ];

  return (
    <div className={className}>
      <PageMedia items={items} />
    </div>
  );
};

export default ExplanatoryVideo;
